import React from 'react'
import { PackType } from '../../types/pack'
import { getPreviewImages } from '../../services/pack'
import { Space } from '../../layouts'
import { PackDeleteButton } from '../PackDeleteButton'
import { ThumbnailPreview } from '../ThumbnailPreview'
import { DetailsPanel } from '../DetailsPanel'
import { Wrapper } from './styled'
import trPlaceholder from '../../assets/tr-placeholder.jpg'

export const PackDetails = ({ pack }: { pack: PackType }) => (
  <>
    <Space mb={4} pl={6} pr={6} pb={6} pt={6}>
      <ThumbnailPreview
        src={getPreviewImages(pack).thumbnailURI || trPlaceholder}
        alt="thumbnail"
      />
    </Space>
    {pack.id ? (
      <Wrapper>
        <DetailsPanel pack={pack} />
        <Space mt={4}>
          <PackDeleteButton pack={pack} />
        </Space>
      </Wrapper>
    ) : null}
  </>
)
